import React, {ReactNode} from 'react';

import DataConnector from 'connect/DataConnector';
import AaSequenceActions from 'molbio/aa-sequences/AaSequenceActions';
import AaSequenceStore from 'molbio/aa-sequences/AaSequenceStore';
import {AaSequenceComplex} from 'molbio/aa-sequences/complex/AaSequenceComplexConstants';
import AaSequenceComplexPreviewBody from 'molbio/aa-sequences/complex/AaSequenceComplexPreviewBody';

interface AaSequenceComplexPreviewProps {
  proteinIds: Array<string>;
}

interface EnhancedAaSequenceComplexPreviewProps {
  proteins: Array<AaSequenceComplex>;
}

class AaSequenceComplexPreviewConnector extends DataConnector<
  AaSequenceComplexPreviewProps,
  EnhancedAaSequenceComplexPreviewProps
> {
  override shouldSubscribeToRedux = false;
  override stores = [AaSequenceStore];

  enhanceProps(): EnhancedAaSequenceComplexPreviewProps {
    // Note that we don't yet handle loading or error states. We may want to do
    // this if it becomes important.
    const proteins: Array<AaSequenceComplex> = [];
    this.props.proteinIds.forEach((proteinId: string) => {
      const aaSequence = this.aaSequenceStore().getAaSequenceById(proteinId);
      if (aaSequence != null) {
        const aaSequenceComplexPreview = {
          name: aaSequence.name,
          aminoAcids: aaSequence.version.aminoAcids,
        };
        proteins.push(aaSequenceComplexPreview);
      }
    });
    return {proteins};
  }
}

class AaSequenceComplexPreview extends React.Component<
  AaSequenceComplexPreviewProps & EnhancedAaSequenceComplexPreviewProps
> {
  override componentDidMount(): void {
    this.props.proteinIds.forEach((proteinId) => {
      AaSequenceActions.open(proteinId, {});
    });
  }

  override render(): ReactNode {
    return <AaSequenceComplexPreviewBody proteins={this.props.proteins} />;
  }
}

export default AaSequenceComplexPreviewConnector.connect(AaSequenceComplexPreview);
